<template>
  <v-card
    class="d-block handle row-handle"
    style="
      background-color: #fff;
      position: absolute;
      margin: auto;
      left: -28px;
      font-size: 15px;
    "
    @click.prevent="$emit('click')"
    @click.stop="$emit('click')"
  >
    <v-icon dense>mdi-drag-vertical</v-icon>
  </v-card>
</template>

<script>
export default {
  name: 'RowBulkSelectButton'
}
</script>

<style scoped>
.handle {
  cursor: grab  !important;
}
</style>
